import { MenuItem } from "../../Type/Layout/Sidebar";
import { itemHasPermission } from "../../utils/helper/helpers";

export const MenuList: MenuItem[] = [
  {
    title: "Gestions",
    Items: [
      {
        icon: "Profile",
        id: 1,
        active: false,
        title: "Utilisateurs",
        permissions: ["admin", "super admin", "gest. utilisateur ecriture", "gest. utilisateur lecture"],
        children: [
          { path: `${process.env.PUBLIC_URL}/gestion-utilisateur`, title: "Utilisateur", type: "link" },
        ]
      },

      {
        icon: "Bag",
        id: 1,
        active: false,
        title: "Magazin",
        permissions: ["admin", 'super admin', 'gest. magazin lecture', 'gest. magazin ecriture'],
        children: [
          { path: `${process.env.PUBLIC_URL}/ventes`, title: "Espace de vente", type: "link" },
          { path: `${process.env.PUBLIC_URL}/venter-historique`, title: "Ventes & Historique", type: "link" },
          { path: `${process.env.PUBLIC_URL}/produits`, title: "Produits", type: "link" },
        ]
      },

      {
        icon: "Buy",
        id: 1,
        active: false,
        title: "Bon de Commande",
        permissions: ["admin", 'super admin', 'gest. bons lecture', 'gest. bons ecriture'],
        children: [
          { path: `${process.env.PUBLIC_URL}/bon-de-commande`, title: "Bon de Commande", type: "link" },
          { path: `${process.env.PUBLIC_URL}/autres-bon-de-commande`, title: "Autres", type: "link" },
        ]
      },

      {
        icon: "Buy",
        id: 1,
        active: false,
        title: "Versements",
        permissions: ["admin", 'super admin', 'gest. versements ecriture', 'gest. versements lecture', 'gest. bons ecriture'],
        children: [
          { path: `${process.env.PUBLIC_URL}/gestion-versements`, title: "Versements", type: "link" },
          { path: `${process.env.PUBLIC_URL}/autres-versement`, title: "Autres", type: "link" },
        ]
      },

      {
        icon: "Profile",
        id: 1,
        active: false,
        title: "Clients",
        permissions: ["admin", 'super admin', 'gest. clients ecriture', 'gest. clients lecture'],
        children: [
          { path: `${process.env.PUBLIC_URL}/Clients`, title: "Listes", type: "link" },
        ]
      },

      // {
      //   icon: "Buy",
      //   id: 1,
      //   active: false,
      //   title: "Versements",
      //   permissions: ["admin", 'super admin', 'gest. versements ecriture', 'gest. versements lecture', 'gest. bons ecriture'],
      //   children: [
      //     (itemHasPermission('super admin') || itemHasPermission('gest. versements ecriture')) && { path: `${process.env.PUBLIC_URL}/ajouter-un-versements`, title: "Ajouter", type: "link" },
      //     { path: `${process.env.PUBLIC_URL}/gestion-versements`, title: "Versements", type: "link" },
      //     // { path: `${process.env.PUBLIC_URL}/materiel`, title: "Materiel", type: "link" },
      //   ].filter(Boolean) as MenuItem[],
      // },

      {
        icon: "Filter-2",
        id: 1,
        active: false,
        title: "Carburant",
        permissions: ["admin", 'super admin', 'gest. carburant ecriture', 'gest. carburant lecture'],
        children: [
          { path: `${process.env.PUBLIC_URL}/bon-de-carburant`, title: "Bon de Carburant", type: "link" },
        ],
      },

      {
        icon: "Edit-line",
        id: 1,
        active: false,
        title: "Caisse",
        permissions: ["admin", 'super admin', 'gest. caisse lecture', 'gest. caisse ecriture', 'gest. factures lecture', 'gest. factures ecriture'],
        children: [
          { path: `${process.env.PUBLIC_URL}/caisses`, title: "Sortie & Rentrer", type: "link" },
          { path: `${process.env.PUBLIC_URL}/synthese-caisse`, title: "Synthèse", type: "link" },
          { path: `${process.env.PUBLIC_URL}/factures`, title: "Factures", type: "link" },
        ],
      },

      {
        icon: "Setting",
        id: 1,
        active: false,
        title: "Paramètres",
        permissions: ["super admin"],
        children: [
          { path: `${process.env.PUBLIC_URL}/gestion-roles`, title: "Roles", type: "link", },
          { path: `${process.env.PUBLIC_URL}/gestion-fournisseur`, title: "Fournisseurs", type: "link" },
          { path: `${process.env.PUBLIC_URL}/gestion-infos-ets`, title: "Infos Ets", type: "link" },
        ],
      },
    ],
  },
];
